(function () {
    'use strict';

    angular
        .module('blocks.auth')
        .factory('userService', userService);

    userService.$inject = ['$window', 'config', 'authDataService', 'notifier', 'bootstrap.dialog', 'survey.dialog', 'dataservice'  ];

    /* @ngInject */
    function userService($window, config, authDataService, notifier, bsDialog,  surveyDialog, dataService) {
        var userDataKey = "7PointUserData";
        var _userData;
        var service = {
            NotAuthenticatedException: NotAuthenticatedException,
            isAuthenticated: isAuthenticated,
            isAuthenticatedThrowError: isAuthenticatedThrowError,
            login: login,
            logout: logout,
            getUserData: getUserData,
            userDataKey: userDataKey,
            userName: userName,
            userId: userId,
            tenantId: tenantId,
            userType: userType,
            departmentIds: departmentIds,
            billingDepartmentIds: billingDepartmentIds,
            hasOps: hasOps,
            apiTypeId: apiTypeId,
            numberOfDisplayTemplates: numberOfDisplayTemplates,
            numberOfPaymentTemplates: numberOfPaymentTemplates,
            activeUntilUtc: activeUntilUtc,
            saveUserConfigOptions: saveUserConfigOptions,
            getAccessToken: getAccessToken,
            userConfigOptions: userConfigOptions,
            filterData: filterData,
            filterTypeId: filterTypeId,
            hasDataApi: hasDataApi,
            isEmsApiType: isEmsApiType,
            checkIsAdmin: checkIsAdmin,
            isMazevoApi: isMazevoApi,
            isCollegeNetApi: isCollegeNetApi

        };

        return service;


        function NotAuthenticatedException(msg) {
            this.name = 'AuthenticationRequired';
            this.message = msg;
            notifier.notify(config.events.authenticationChange);
        }

        function getAccessToken(externalAccessToken, successCallback, errorCallback) {
            authDataService.getAccessToken(externalAccessToken).then(function (response) {
                if (response) {
                    if (response.status !== 200) {
                        if (response.data) {
                            errorCallback(response.data.description || response.data.Message || "Unknown error trying to login");
                        }
                    }
                    else {
                        _finalizeLogin(response.data, successCallback, errorCallback);
                    }
                }
                else {
                    errorCallback(response.data.description || response.data.Message || "Unknown error trying to login");
                }
                
            }, function (e) {
                if (typeof errorCallback === 'function') {
                    if (e && e.data) {
                        errorCallback(e.data.description || e.data.Message || "Unknown error trying to login");
                    }
                    else {
                        errorCallback("Unknown error trying to login.");
                    }
                }
            });
        }

        function _setUserData(d) {
            
            var userData = {};
            userData.isAuthenticated = true;
            userData.userName = d.UserName;
            userData.userType = d.UserType;
            userData.userId = d.UserId;
            userData.tenantId = d.TenantId;
            userData.bearerToken = d.access_token;
            userData.refreshToken = d.refresh_token;
            userData.hasOps = d.HasOps;
            userData.numberOfPaymentTemplates = d.NumberOfPaymentTemplates;
            userData.numberOfDisplayTemplates = d.NumberOfDisplayTemplates;
            userData.departmentIds = d.DepartmentIds;
            userData.billingDepartmentIds = d.BillingDepartmentIds;
            userData.activeUntilUtc = d.ActiveUntilUtc;
            userData.apiTypeId = d.ApiTypeId;
            userData.expirationDate = new Date(d['.expires']);
            userData.filterTypeId = d.FilterTypeId;
            userData.hasDataApi = d.HasDataApi;

            _saveUserData(userData);

            authDataService.getFilterData(userData.filterTypeId).then(function (response) {
                userData.filterData = response.data;
                _saveUserData(userData);
             
            }, function (error) { console.log("problem loading filter " + error); })

        }

        function _finalizeLogin(d, successCallback, errorCallback) {
            if (d.NeedsToAcceptTerms == "1") {
                return bsDialog.confirmationDialog("Terms", "", "Agree", "Decline", 'app/dialogs/_terms.html').then(function (result) {
                    _setUserData(d);
                    authDataService.acceptTerms().then(function (x) {
                        notifier.notify(config.events.authenticationChange);
                        if (typeof successCallback === 'function') {

                            successCallback();
                        }
                    }, function (e) { });

                }, function () {
                    errorCallback("Login failed. User declined terms.");
                });
            }
            else {
                _setUserData(d);

                if (d.SurveyToShowUId) {
                    surveyDialog.display({ SurveyUId: d.SurveyToShowUId }).then(function () { }, function () { });
                }

                notifier.notify(config.events.authenticationChange);

                if (typeof successCallback === 'function') {
                    successCallback();
                }
            }
        }


        function login(data, successCallback, errorCallback) {

            authDataService.login(data).then(function (response) {
                if (response.status === 400) {
                    handleError(response);
                }
                else {
                    _finalizeLogin(response.data, successCallback, errorCallback);
                }
                

            }, handleError);

            function handleError(e) {
                if (typeof errorCallback === 'function') {
                    if (e && e.data && e.data.error_description) {
                        errorCallback("Login failed. " + e.data.error_description);
                    }

                    else {
                        errorCallback("Unknown error trying to login.");
                    }
                }
            }

        }
           
        function _saveUserData(userData) {
            $window.localStorage.setItem(userDataKey, JSON.stringify(userData));
        }

        function saveUserConfigOptions(updateDto, selectedFilterData) {

            authDataService.saveUserConfigOptions(updateDto);
            var userData = getUserData();
            userData.filterTypeId = updateDto.filterTypeId;
            userData.filterData = selectedFilterData;
            _saveUserData(userData);

        }

        function logout() {
            dataService.saveItem('api/Account/logout').then(function (response) {
                clearUserData();
                notifier.notify(config.events.authenticationChange);
            }, function (error) {
                clearUserData();
                notifier.notify(config.events.authenticationChange);
            });
           
        }

        function isAuthenticatedThrowError() {
            if (!isAuthenticated()) {
                throw new NotAuthenticatedException("User Not Authenticated");
            }
            return true;
        }

        function isAuthenticated() {
            var userData = getUserData();
            if (userData && userData.isAuthenticated) {
                //return (userData.isAuthenticated && !isTokenExpired(userData.expirationDate))
                return (userData.isAuthenticated)
            }
            return false;
        }

        function _getRefreshToken() {
            var userData = getUserData();
            if (userData && userData.refreshToken) {
                return (userData.refreshToken);
            }
            return "";
        }

        function userId() {
            var userData = getUserData();
            if (userData && userData.userId) {
                return (userData.userId);
            }
            return "Guest";
        }

        function hasDataApi() {
            var userData = getUserData();
            if (userData && userData.hasDataApi) {
                return userData.hasDataApi;
            }
            return "0";
        }

        function tenantId() {
            var userData = getUserData();
            if (userData && userData.tenantId) {
                return userData.tenantId;
            }
            return "-1";
        }

        function activeUntilUtc() {
            var userData = getUserData();
            if (userData && userData.activeUntilUtc) {
                return userData.activeUntilUtc;
            }
            return "";
        }

        function apiTypeId() {
            var userData = getUserData();
            if (userData && userData.apiTypeId) {
                return userData.apiTypeId.toUpperCase();
            }
            return "";
        }

        function isEmsApiType() {
            
            var ourApi = "BCA944F7-7795-45CD-A21B-CB5F16DC4175";
            var psApi = "4CF523BF-F6DD-441C-810F-C87347963B5D";
            var apiType = apiTypeId();
            if (apiType == ourApi || psApi == apiType) {
                return true;
            }
            else {
                return false;
            }

        }

        function isMazevoApi() {

            var apiTypeId = "0E9DADB2-F56B-4E7E-A3B2-A59632C91D86";
            var userData = getUserData();
            var apiType = "";
            if (userData && userData.apiTypeId) {
                apiType = userData.apiTypeId.toUpperCase();
            }
            
            if (apiType == apiTypeId) {
                return true;
            }
            else {
                return false;
            }

        }

        function isCollegeNetApi() {

            var apiTypeId = "355A9B3B-BF7E-4D96-8B06-27B310EB01F0";
            var userData = getUserData();
            var apiType = "";
            if (userData && userData.apiTypeId) {
                apiType = userData.apiTypeId.toUpperCase();
            }

            if (apiType == apiTypeId) {
                return true;
            }
            else {
                return false;
            }

        }


        function hasOps() {
            var userData = getUserData();
            if (userData && userData.hasOps) {
                return userData.hasOps;
            }
            return "0";
        }

        function numberOfDisplayTemplates() {
            var userData = getUserData();
            if (userData && userData.numberOfDisplayTemplates) {
                return userData.numberOfDisplayTemplates;
            }
            return "0";
        }

        function numberOfPaymentTemplates() {
            var userData = getUserData();
            if (userData && userData.numberOfPaymentTemplates) {
                return userData.numberOfPaymentTemplates;
            }
            return "0";
        }

        function userName() {
            var userData = getUserData();
            if (userData && userData.userName) {
                return (userData.userName);
            }
            return "Guest";
        }

        function userType() {
            var userData = getUserData();
            if (userData && userData.userType) {
                return (userData.userType);
            }
            return "0";
        }

        function departmentIds() {
            var userData = getUserData();
            if (userData && userData.departmentIds) {
                return userData.departmentIds.split(',');
            }
            return [];
        }

        function billingDepartmentIds() {
            var userData = getUserData();
            if (userData) {
                if (userData.billingDepartmentIds && userData.billingDepartmentIds.length > 0) {
                    return userData.billingDepartmentIds.split(',');
                }
            }
            return [];
        }

        function checkIsAdmin() {
            return authDataService.checkIsAdmin().then(function (response) {
                return response.data;
            }, function (error) { });
            
        }

        function filterTypeId() {
            var userData = getUserData();
            if (userData && userData.filterTypeId) {
                return userData.filterTypeId;
            }
            return 0;
        }


        function filterData() {
            var userData = getUserData();
            if (userData) {
                if (userData.filterData) {
                    return userData.filterData;
                }
            }
            return {};
        }

        function userConfigOptions() {
            var userData = getUserData();
            if (userData && userData.configOptions) {
                var base64Options = userData.configOptions;
                if (base64Options) {
                    return angular.fromJson(atob(base64Options));
                }
            }
            return {};
        }

        function getUserData() {
            //if (!_userData) {
            var s = $window.localStorage.getItem(userDataKey);
            if (s) {
                try {
                    //_userData = JSON.parse($window.localStorage.getItem(userDataKey));
                    return JSON.parse($window.localStorage.getItem(userDataKey));
                }
                catch (error) { }
            }
            else {
                //  _userData = null;
            }
            //}
            //return _userData;
            return null;
        }


        function isTokenExpired(expirationDate) {
            var now = new Date();
            expirationDate = new Date(expirationDate);
            if (expirationDate - now > 0) {
                return false;
            }
            else {
                try {
                    return refreshToken().then(function () {
                        return false;
                    });
                }
                catch (refreshTokenError) {
                    
                    clearUserData();
                    return true;
                }

                
                
            }
        }

        function clearUserData() {
            _userData = null;
            $window.localStorage.removeItem(userDataKey);
        }
    }
}());
